const {
  isRangeYear,
  isRangeMonth,
  isRangeQuarter,
  isRangeMonthQuarterOrYear,
  getFirstAndLastDatesInCalendarPeriod,
} = require('date-functions');

module.exports = {
  isRangeYear,
  isRangeMonth,
  isRangeQuarter,
  isRangeMonthQuarterOrYear,
  getFirstAndLastDatesInCalendarPeriod,
};
